export const featuredCollections = [
  {
    id: 'workplace',
    label: '職場穿搭',
    subtitle: 'Workplace Style',
    desc: '俐落剪裁，展現專業自信',
    count: 48,
    image: 'https://readdy.ai/api/search-image?query=elegant%20professional%20asian%20woman%20wearing%20sophisticated%20beige%20blazer%20and%20tailored%20trousers%2C%20minimalist%20office%20fashion%20editorial%2C%20warm%20cream%20tones%2C%20clean%20white%20background%2C%20high-end%20workwear%20style%2C%20polished%20and%20refined%20appearance%2C%20professional%20yet%20stylish%20outfit%2C%20natural%20soft%20lighting%2C%20fashion%20magazine%20quality%20photo&width=600&height=800&seq=collection-work-001&orientation=portrait',
  },
  {
    id: 'casual',
    label: '週末休閒',
    subtitle: 'Weekend Casual',
    desc: '輕鬆自在，盡顯生活態度',
    count: 62,
    image: 'https://readdy.ai/api/search-image?query=stylish%20asian%20woman%20wearing%20casual%20chic%20cream%20linen%20outfit%2C%20relaxed%20weekend%20fashion%2C%20soft%20warm%20natural%20light%2C%20minimalist%20aesthetic%2C%20comfortable%20yet%20fashionable%20clothing%2C%20light%20beige%20and%20white%20tones%2C%20airy%20and%20effortless%20style%2C%20outdoor%20lifestyle%20fashion%20photography%2C%20clean%20background&width=600&height=800&seq=collection-casual-001&orientation=portrait',
  },
  {
    id: 'dress',
    label: '優雅洋裝',
    subtitle: 'Elegant Dress',
    desc: '質感單品，成就每個重要時刻',
    count: 35,
    image: 'https://readdy.ai/api/search-image?query=beautiful%20asian%20woman%20wearing%20luxurious%20flowing%20elegant%20dress%20in%20cream%20and%20gold%20tones%2C%20sophisticated%20feminine%20style%2C%20upscale%20fashion%20editorial%2C%20soft%20studio%20lighting%20with%20warm%20amber%20accents%2C%20graceful%20and%20refined%20appearance%2C%20high-end%20dress%20collection%2C%20clean%20neutral%20background&width=600&height=800&seq=collection-dress-001&orientation=portrait',
  },
];
